import {memo, PropTypes, propTypesExact, shapeComponent, ShapeComponent, StyleSheet, Text, View} from "shared/base"
import React, {useMemo} from "react"
import {digs} from "diggerize"
import {HelperText} from "react-native-paper"
import {Pressable} from "react-native"
import {useForm} from "@kaspernj/api-maker/build/form"
import useInput from "@kaspernj/api-maker/build/use-input"

const styles = StyleSheet.create({
  checkIcon: {color: "#5253ff"},
  hintContainer: {marginTop: 4},
  iconContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 17,
    height: 17,
    backgroundColor: "#cbcbcb",
    borderRadius: 7
  },
  labelContainer: {marginLeft: 12},
  pressable: {display: "flex", flexDirection: "row", alignItems: "center"}
})

/**
 * @typedef {object} ComponentsUtilsCheckboxProps
 * @property {unknown} checked
 * @property {unknown} dataSet
 * @property {unknown} fontStyle
 * @property {unknown} hint
 * @property {unknown} label
 * @property {unknown} labelContent
 * @property {unknown} name
 * @property {unknown} onChange
 * @property {unknown} onChangeChecked
 * @property {unknown} style
 * @property {unknown} value
 */

/** @typedef {object} ComponentsUtilsCheckboxState */

/**
 * @extends {ShapeComponent<ComponentsUtilsCheckboxProps, ComponentsUtilsCheckboxState>}
 */
class ComponentsUtilsCheckbox extends ShapeComponent {
  static defaultProps = {
    value: undefined
  }

  static propTypes = propTypesExact({
    checked: PropTypes.bool.isRequired,
    dataSet: PropTypes.object,
    fontStyle: PropTypes.object,
    hint: PropTypes.node,
    label: PropTypes.string,
    labelContent: PropTypes.node,
    name: PropTypes.string,
    onChange: PropTypes.func,
    onChangeChecked: PropTypes.func,
    style: PropTypes.object,
    value: PropTypes.object
  })

  setup() {
    const {name, checked} = this.props
    const {wrapperOpts} = useInput({props: this.props, wrapperOptions: {type: "input"}})
    const {errors} = digs(wrapperOpts, "errors")

    this.errors = errors
    this.form = useForm()

    // Set initial value in form
    useMemo(() => {
      if (this.form && name) {
        this.form.setValue(name, checked)
      }
    }, [])
  }

  render() {
    const {errors} = this.tt
    const {checked, dataSet, fontStyle, hint, label, labelContent, style} = this.props
    const actualDataSet = Object.assign({}, dataSet, {checked})

    return (
      <View dataSet={actualDataSet} style={style}>
        <Pressable
          onPress={this.tt.onRadioButtonPressed}
          style={styles.pressable}
          testID="checkbox-pressable"
        >
          <View style={styles.iconContainer}>
            {checked &&
              <Text style={styles.checkIcon}>
                ✓
              </Text>
            }
          </View>
          {(label || labelContent) &&
            <View style={styles.labelContainer}>
              {label &&
                <Text style={fontStyle}>
                  {label}
                </Text>
              }
              {labelContent}
            </View>
          }
        </Pressable>
        {hint &&
          <View style={styles.hintContainer}>
            <Text>
              {hint}
            </Text>
          </View>
        }
        {errors.length > 0 &&
          <HelperText dataSet={this.helperTextDataSet ||= {class: "errors-helper-text"}} type="error">
            {this.errorMessages().join(". ")}
          </HelperText>
        }
      </View>
    )
  }

  onRadioButtonPressed = () => {
    const {form} = this.tt
    const {name} = this.props
    const newChecked = !this.p.checked

    if (form && name) {
      form.setValue(name, newChecked)
    }

    if (this.props.onChange) {
      this.p.onChange({
        checked: newChecked,
        label: this.p.label,
        value: this.p.value
      })
    }

    if (this.props.onChangeChecked) {
      this.p.onChangeChecked(newChecked)
    }
  }
}

export default memo(shapeComponent(ComponentsUtilsCheckbox))
